import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/lathe-grey.jpg'


const _hoisted_1 = {
  class: "about-section text-center",
  id: "about"
}
const _hoisted_2 = { class: "container px-4 px-lg-5" }
const _hoisted_3 = { class: "row gx-4 gx-lg-5 justify-content-center" }
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-white mb-4" }, " hand crafted whistles in wood, aluminium and brass ", -1)
const _hoisted_6 = { class: "text-white-50" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Ironwood whistles is a small tin whistle manufacturer in the beautiful German region of "),
  /*#__PURE__*/_createElementVNode("i", null, "Eifel"),
  /*#__PURE__*/_createTextVNode(". I build whistles primarily in wood but offer instruments made from aluminium and brass, as well. I do not mass produce or use industrialized processes - each instrument is unique and made with love and devotion to the craft. ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-100"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkComponent = _resolveComponent("LinkComponent")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("p", null, [
              _createVNode(_component_LinkComponent, {
                "link-text": "Contact ironwood",
                href: "#contact",
                inverted: true
              }),
              _createTextVNode(" for more information, available whistles or custom orders. ")
            ])
          ])
        ])
      ])
    ])
  ]))
}